import dayjs from "dayjs";
import { useCallback } from "react";
import { useStore } from "stook";

// 用于存储用户填写的信息
interface IBaseInfo {
  userName: string; //用户姓名
  mobile?: string; //联系号码
  plateNo: string; //车牌
  vin?: string; // 车辆 VIN
  vehicleId?: string; // 车辆 ID
  carId?: string; // 车辆 ID 兜底字段
  carInfoSource?: string; // 车辆信息来源
  rescueReason?: string; //救援原因
  rescueReasonDetail?: string; //救援原因详情（子选项）
  hasTowbar: string; //拖车钩
  carPosition: string; //停放场所
  rescueReasonRemarks: string;
  rescueType: string; // 救援方式
  rescueTime: string; // 救援时间
}

let INIT_BASE_DATA: IBaseInfo = {
  userName: "",
  mobile: "",
  plateNo: "",
  vin: "",
  vehicleId: "",
  carId: "",
  carInfoSource: "",
  rescueReason: "",
  rescueReasonDetail: "",
  hasTowbar: "",
  carPosition: "",
  rescueReasonRemarks: "",
  rescueType: "timelyRescue",
  rescueTime: dayjs().format("YYYY-MM-DD HH:mm"),
};

if (process.env.REACT_APP_DELOY_ENV === "test") {
  INIT_BASE_DATA = {
    userName: "江先生",
    mobile: "13111117767",
    plateNo: "粤B222111",
    hasTowbar: "1",
    carPosition: "01",
    rescueType: "timelyRescue",
    rescueTime: dayjs().format("YYYY-MM-DD HH:mm"),
    rescueReasonRemarks: "车辆描述",
    rescueReason: "003",
    rescueReasonDetail: "001",
  };
}

export default function useBaseInfoHook() {
  const [baseInfo, setBaseInfo] = useStore<IBaseInfo>(
    "BaseInfo",
    INIT_BASE_DATA,
  );

  // 更新字段信息
  const updateBaseInfo = useCallback(
    (type, value) => {
      setBaseInfo((prevBaseInfo) => {
        return Object.assign({}, prevBaseInfo, {
          [type]: value,
        });
      });
    },
    [setBaseInfo],
  );

  const resetBaseInfo = useCallback(() => {
    setBaseInfo(INIT_BASE_DATA);
  }, [setBaseInfo]);

  return {
    baseInfo,
    setBaseInfo,
    updateBaseInfo,
    resetBaseInfo,
  };
}
